export const navigation = {
  labels: {
    helpAndSupport: "Help and support",
    openNavSidebar: "Open navigation sidebar",
    home: "Home",
    staffSettings: "Staff settings",
    integrations: "Integrations",
    AddAPatient: "Create new {{patientTerm}}",
    newPrescription: "New {{treatmentPlanTerm}}",
    staff: "Staff",
    patients: "{{patientTermCapitalized}}s",
    accountSettings: "Account settings",
    actions: "Actions",
    reports: "Reports",
    WholesalePolicies: "Wholesale policies",
    resourceLibrary: "Resource library",
    Plans: "Plans",
    catalog: "Catalog",
    Insights: "Insights",
    Favorites: "Favorites",
    dashboard: "Dashboard",
    Protocols: "Protocols",
    Search: "Search",
    openPatientSearch: "Open {{patientTerm}} search input",
    dispensarySettings: "Dispensary settings",
    backToDispensarySettings: "Back to dispensary settings",
    helpUsGrow: "Help us grow!",
    inventory: "Inventory",
    locationManagement: "Location management",
    logout: "Logout",
    orders: "Orders",
    share: "Share",
    switchAccount: "Switch account",
    newPatient: "New {{patientTerm}}",
    new: "New",
    uploadCredentialsToAccess: "Upload healthcare credentials to access these pages.",
    recommendationsDropdown: {
      Protocols: "Protocols",
      allPrescriptions: "All {{treatmentPlanTerm}}",
      SharedPlans: "Shared plans",
      IndividualPlans: "Individual plans",
    },
    catalogDropdown: {
      Search: "Search",
      favorites: "Favorites",
      adherence: "Adherence",
      productSwapping: "Product swapping",
    },
    clientsDropdown: {
      allPatients: "All {{patientTerm}}",
    },
    WholesaleOrders: "Wholesale orders",
    PatientOrders: "{{patientTerm}} orders",
    AllPatients: "All {{patientTermPlural}}",
    CreateProtocol: "Create protocol",
    TaxExemption: "Tax exemption",
  },
  homepageDropdown: {
    prescription: {
      label: "Create new {{treatmentPlanTerm}}",
      description: "Build new {{treatmentPlanTerm}}",
    },
    lab: {
      label: "Create lab recommendation",
      description: "Markers, panels and kits",
    },
    protocol: {
      label: "Build shareable protocol",
      description: "New shareable wellness protocol",
    },
    patient: {
      label: "Create {{patientTerm}} profile",
      description: "Add a new {{patientTerm}} to your dispensary",
    },
    staff: {
      label: "Add new staff",
      description: "Grow your practice in an instant",
    },
    buildPlan: "Build plan",
    createPatient: "Create {{patientTerm}}",
    addStaff: "Add staff",
  },
  cart: {
    yourCart: "Your cart",
    countItem: "{{itemCount}} item",

    countItem_plural: "{{itemCount}} items",
    free: "FREE",
    Taxes: "Taxes",
    Subtotal: "Subtotal",
    Shipping: "Shipping",
    Savings: "Savings",
    USDTotal: "Total (USD)",
    goToCheckout: "Go to checkout",
    freeShipping: "Free priority shipping over ${{freeShippingThreshold}}",
    heatSensitive: "Cold packs included with heat sensitive items",
    shippingTime: "Standard shipping arrives in 3-6 business days",
    becomeTaxExempt: "Become tax exempt on Fullscript",
    nothingInCart: "You have nothing in your cart",
    needCertifications:
      "To place wholesale orders, you will need to <0>upload your professional credentials</0>",
    needOnboardingCompleted:
      "To place wholesale orders, you will need to <0>complete account setup</0>",
    reviewingCredentials:
      "Fullscript is reviewing your professional credentials. Once approved, you'll be able to place your order. This typically takes 24 hours. ",
    editAria: "Edit {{name}} created on {{createdAt}}",
    toggleCart: "toggle-cart",
  },
  notifications: {
    title: "Notifications",
    toggleNotifications: "Open notifications",
    wholesaleCertification: "Your wholesale certification for {{state}} will expire in {{time}}.",
    renewItNow: "Renew it now.",
    emptyMessage: "No new notifications",
    day: "{{count}} day",
    day_plural: "{{count}} days",
    npSyncInProgress:
      "Your Natural Partners account is being imported. This may take up to 24 hours.",
    modal: {
      npSyncInProgressTitle: "Import in progress",
      npSyncInProgressTextOne:
        "Your Fullscript account and Natural Partners account are now being synchronized. Your Fullscript account will be updated to include your Natural Partners data.",
      npSyncInProgressTextTwo: "Please allow 24 hours for the synchronization to complete.",
      npSyncInProgressTextThree:
        'Once completed, you will be able to find Natural Partners order and item history in both catalog and search, under the "previously ordered" filter.',
      npSyncInProgressTextFour: "Until then, you may continue to use the platform like normal.",
    },
  },
} as const;
